<template>
    <div id="bene-nz-bt-business-container">
        <f7-list form class="form-group" v-if="showFormInput.kaasiDetails.nzBusiness">
            <f7-list-input
                input-id     ="nzbn"
                name         ="nzbn"
                type         ="text"

                :label       ="$t('beneficiary-nzbn')"
                :placeholder ="$t('beneficiary-nzbn')"
                :value       ="nzbn"
                @change      ="setNzbn($event.target.value); validateInput($event.target); setInput($event.target)"

                autocomplete ="off"
                outline
                floating-label
                clear-button
            ></f7-list-input>
        </f7-list>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from "vuex";
    export default {
        props: {
        },
        mounted() {
        },
        data: function() {
            return {}
        },
        computed: {
            ...mapGetters('beneficiary', [
                'showFormSet',
                'showFormInput',
                'nzbn'
            ])
        },
        methods: {
            ...mapActions('beneficiary', [
                'setNzbn'
            ]),

            validateInput(inputEl){
                this.$emit("validateInput", inputEl);
            },

            setInput(inputEl){
                this.$emit("setInput", inputEl);
            }
        }
    }
</script>